import history from "../history";
import { CONFIG } from "../config";
import accountManagement from "../apis/accountManagement";
import { SIGN_IN, CEK_COOKIES, FETCH_ERROR, SIGN_OUT, FETCH_MENU } from "./types";
import { clearSession, readSessionUser } from "../apis/apiSession";

const errorObj = {type: '', message: ''};
let base64 = require('base-64');
// HTTP 429: too_many_attempts from the login service, or the gateway limit without a JSON body.
const tooManyAttempts = data => ({
    error: (data && data.error) || 'too_many_attempts',
    error_description: (data && typeof data.error_description === 'string' && data.error_description.trim())
        || 'Terlalu banyak percobaan masuk. Coba lagi beberapa saat lagi.'
});
export const signIn = (userInfo) => dispatch => {
    fetch(process.env.REACT_APP_API_AUTH + '/oauth/token', {
        method: "POST",
        headers: {
            'Authorization': 'Basic ' + base64.encode("eduprime:066f0dffa608814d2adff4b922f00c610f09b9f568dad28274f04227ac1f41a7")
        },
        body: userInfo
    })
    .then(res => res.status === 429 ? res.json().catch(() => ({})).then(tooManyAttempts) : res.json())
    .then(data => {        
        if(data.error) {
            // A new object per failure: the login page shows the latest message, not the previous one.
            dispatch({
                type: FETCH_ERROR,
                payload: {type: 'error', message: data.error_description}
            })
            //history.push('/login');
        } 
        else {
            localStorage.setItem("user", JSON.stringify(data));
            dispatch({
                type: SIGN_IN,
                payload: data
            })
            errorObj.type = 'success';
            errorObj.message = 'success';
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            //history.push('dashboard');
            window.location.assign('/dashboard')
        }
    })
}

export const signOut = () => async (dispatch) => {
  clearSession();

  errorObj.type = "success";
  errorObj.message = "User Logged Out...!!";
  dispatch({
    type: SIGN_OUT,
    payload: null,
  });
  history.push("/login");
};

export const cekCookies =
  (fromPage = null) =>
  async (dispatch) => {
    const user = readSessionUser();

    if (user === null) {
      // Opening the login page without a session is normal: no error, and a redirect's message stays.
      if (fromPage === "login") return;
      errorObj.type = "error";
      errorObj.message = "Not authorized";
      dispatch({
        type: FETCH_ERROR,
        payload: errorObj,
      });
      history.push("/login");
    } else {
      dispatch({
        type: CEK_COOKIES,
        payload: user,
      });
      errorObj.type = "success";
      errorObj.message = "success";
      dispatch({
        type: FETCH_ERROR,
        payload: errorObj,
      });

      const responseMenu = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_FETCH_MENU + user.idRole).catch(function (error) {
        errorObj.type = "error";
        errorObj.message = error.message;
        dispatch({
          type: FETCH_ERROR,
          payload: errorObj,
        });
      });
      if (responseMenu) {
        if (responseMenu.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          dispatch({
            type: FETCH_MENU,
            payload: responseMenu.data,
          });
          if (fromPage === "login") {
            history.push("/dashboard");
          }
        }
      }
    }
  };
